<template>
  <div>
    <v-container>
      <v-row class="text-center">
        <v-col cols="12">
          <h2 class="section-title text-center">{{ $t("myDates") }}</h2>
        </v-col>
      </v-row>
      <v-row>
        <!-- <v-col cols="3" sm="2">
          <div class="icons">
            <v-icon large color="#13a8b1">search</v-icon>
            <v-icon large color="#13a8b1">filter_alt</v-icon>
          </div>
        </v-col>-->
        <v-col cols="12" sm="12" class="d-none d-sm-block text-center">
          <ul class="list-unstyled list-inline">
            <li :class="currentTab == 'pending' ? 'active' : ''">
              <span class="notic">{{ counters.pending }}</span>
              <span class="content" @click="changeStatus('pending')">
                {{ $t("pendingTeacherConfirm") }}
              </span>
            </li>
            <li :class="currentTab == 'confirmed' ? 'active' : ''">
              <span class="notic">{{ counters.confirmed }}</span>
              <span class="content" @click="changeStatus('confirmed')">
                {{ $t("pendingPayment") }}
              </span>
            </li>
            <li :class="currentTab == 'upcoming' ? 'active' : ''">
              <span class="notic">{{ counters.upcoming }}</span>

              <span class="content" @click="changeStatus('upcoming')">
                {{ $t("upcoming") }}
              </span>
            </li>
            <li :class="currentTab == 'previous' ? 'active' : ''">
              <span class="notic">{{ counters.previous }}</span>
              <span
                class="content"
                :class="currentTab == 'previous' ? 'active' : ''"
                @click="changeStatus('previous')"
                >{{ $t("past") }}</span
              >
            </li>

            <li :class="currentTab == 'cancelled' ? 'active' : ''">
              <span class="notic">{{ counters.cancelled }}</span>
              <span class="content" @click="changeStatus('cancelled')">
                {{ $t("cancelled") }}
              </span>
            </li>
          </ul>
        </v-col>

        <v-col cols="12" sm="12" class="d-flex d-sm-none">
          <v-row>
            <v-col cols="12" style="padding: 0 12px;">
              <label for="lectures">{{ $t("Sessions") }}</label>
            </v-col>
            <v-col cols="12" style="padding: 0 12px;">
              <v-select
                solo
                :items="items"
                item-text="text"
                item-value="value"
                v-model="selectedStatus"
                @change="changeStatus(selectedStatus)"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="sessions"
            :items-per-page="10"
            class="elevation-1 schedule-table"
            hide-default-footer
          >
            <template v-slot:item.teacher_name="{ item }">
              <img
                :src="
                  item.teacher_img != ''
                    ? item.teacher_img
                    : item.title == 'mr'
                    ? defaultAvaterMale
                    : defaultAvaterfeMale
                "
                height="50px"
                width="50px"
                class="teacher-img"
              />
              <!-- <img
                src="../../assets/images/women.png"
                alt
                height="50px"
                width="50px"
                class="teacher-img"
                v-else
              /> -->
              <p class="text-center teacher-name">{{ item.teacher_name }}</p>
              <div class="rate text-center" v-if="item.rating_count >= 3">
                <v-icon small :color="item.rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                  >star_rate</v-icon
                >
                <v-icon small :color="item.rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                  >star_rate</v-icon
                >
                <v-icon small :color="item.rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                  >star_rate</v-icon
                >
                <v-icon small :color="item.rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                  >star_rate</v-icon
                >
                <v-icon small :color="item.rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                  >star_rate</v-icon
                >
              </div>
            </template>

            <template
              v-slot:item.cancelled_by="{ item }"
              v-if="currentTab == 'cancelled'"
            >
              <p class="grey--text" style="font-size: 13px">
                {{ $t("cancelled_by") }}
                <strong style="color: #fda5a5">{{
                  $t(item.cancelled_by)
                }}</strong>
              </p>
            </template>

            <template v-slot:item.type="{ item }">
              <span v-if="item.type == 'multiple'">{{ $t("Group") }}</span>
              <span v-else>{{ $t("Single") }}</span>
              <span></span>
            </template>
            <template v-slot:item.day="{ item }">
              <p class="date" style="font-weight: bold">
                <v-icon
                  class="main-color"
                  :title="$t('collioding_msg')"
                  v-if="item.collioding"
                  >pan_tool</v-icon
                >
                {{ item.day + " " + item.date + " " }}
              </p>
              <p class="date" style="font-weight: bold">
                {{
                  item.start +
                    " " +
                    item.start_prefix +
                    " - " +
                    item.end +
                    " " +
                    item.end_prefix
                }}
              </p>
            </template>

            <template v-slot:item.total="{ item }">
              <p class="main-color">
                {{ item.total }} {{ $t("currency") }} + {{ item.website_fees }}
                {{ $t("currency") }} {{ $t("websiteFees") }} <br />
                + {{ item.tax_amount }} {{ $t("currency") }}
                {{ $t("tax") }}
              </p>
            </template>

            <!-- <template v-slot:item.rate="{}">
              <div class="rate text-center" @click="openRatingDialog">
                <v-icon color="#ffc382">star_rate</v-icon>
                <v-icon color="#ffc382">star_rate</v-icon>
                <v-icon color="#ffc382">star_rate</v-icon>
                <v-icon color="#ffc382">star_rate</v-icon>
                <v-icon color="#ffc382">star_rate</v-icon>
              </div>
            </template>-->
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                class="table-btn"
                v-if="currentTab == 'confirmed'"
                @click="goToPaymentPage(item.id, item.type)"
                style="margin: 5px"
              >
                {{ $t("moveToPayment") }}
                <v-icon class="action white--text" style="margin-right: 10px"
                  >payment</v-icon
                >
              </v-btn>
              <v-btn
                color="primary"
                icon
                v-if="currentTab == 'upcoming'"
                :disabled="!item.show_session_btn"
                :to="'/session/rules/' + item.id"
                style="margin: 10px"
              >
                <v-icon large>video_call</v-icon>
              </v-btn>
              <v-btn
                color="error"
                class="error-btn"
                v-if="
                  (currentTab == 'pending' ||
                    currentTab == 'confirmed' ||
                    currentTab == 'upcoming') &&
                    item.can_cancel == true
                "
                @click="cancel(item.id)"
              >
                {{ $t("cancel") }}
                <!-- <v-icon
                  :title="$t('cancel')"
                  style="margin-right: 10px;"
                  class="action white--text"
                  >cancel</v-icon
                > -->
              </v-btn>
            </template>
          </v-data-table>

          <div class="text-center pagination">
            <v-pagination
              v-model="page"
              :length="total"
              color="#ffc382"
              v-if="total > 1"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- confirm dialog -->
    <v-dialog v-model="cancelDialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeCancelDialog()">
            <v-icon class="main-color" color="#fda5a5">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">{{
          $t("cancelAppointment")
        }}</v-card-title>

        <div>
          <v-container style="">
            <v-row>
              <v-col>
                <p class="grey--text darken" style="margin-bottom: 0">
                  {{ $t("cancelAppointmentQuestion") }}
                </p>
                <p
                  class="grey--text darken"
                  style="margin-bottom: 0"
                  v-if="cancellation_fees_applies"
                >
                  {{ $t("cancellation_fees_applies") }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="confirm-btn" @click="cancelSession" text>{{
            $t("agree")
          }}</v-btn>
          <v-btn class="cancel-btn" text @click="closeCancelDialog">{{
            $t("disagree")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- wallet payment dialog -->
    <v-dialog
      v-model="walletDialog"
      class="walletDialog"
      max-width="500"
      style="z-index: 8888"
    >
      <v-card style="padding: 10px">
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeWalletDialog()">
            <v-icon class="main-color" color="#13a8b1">close</v-icon>
          </v-btn>
        </div>
        <v-card-title class="main-color">{{
          $t("confirmPayment")
        }}</v-card-title>

        <div>
          <v-container>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("walletBalance") }} :
                </p>
              </v-col>
              <v-col cols="6">
                <p class="gray--text darken margin-bottom-0">
                  {{ available_balance }} {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("teacherName") }} :
                </p>
              </v-col>
              <v-col cols="6">
                <p class="gray--text darken margin-bottom-0">
                  {{ teacher_name }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("sessionFees") }} :
                </p>
              </v-col>
              <v-col cols="6">
                <p class="gray--text darken margin-bottom-0">
                  {{ amount }} {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("Website Fees") }} :
                </p>
              </v-col>
              <v-col cols="6">
                <p class="gray--text darken margin-bottom-0">
                  {{ website_fees }} {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("tax") }} (%{{ tax_percentage }}) :
                </p>
              </v-col>
              <v-col cols="6">
                <p class="gray--text darken margin-bottom-0">
                  {{ tax_amount }} {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">
                  {{ $t("Total Fees") }}:
                </p>
              </v-col>
              <v-col cols="6">
                <p class="margin-bottom-0 gray--text darken">
                  {{ totalFees }} {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <p class="main-color margin-bottom-0">المتبقى فى المحفظة:</p>
              </v-col>
              <v-col cols="6">
                <p class="margin-bottom-0 gray--text darken">
                  {{ parseInt(available_balance) - parseInt(totalFees) }}
                  {{ $t("currency") }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div class="text-center action-div" style="margin-bottom: 20px">
          <v-btn class="primary-btn main-color" @click="payWithWallet" text
            >{{ $t("completePayment") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmWalletPaymentDialog" max-width="500">
      <v-card>
        <div
          class="close-btn"
          :class="locale == 'en' ? 'text-right' : 'text-left'"
        >
          <v-btn color text @click="closeconfirmDialog()">
            <v-icon class="main-color">{{ $t("close") }}</v-icon>
          </v-btn>
        </div>
        <v-card-title class="headline main-color">
          {{ successTitle }}
        </v-card-title>

        <div>
          <v-container style="padding: 1rem !important">
            <v-row>
              <v-col>
                <p class="text-center grey--text darken">
                  {{ successMessage }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="modal-btn">
            <v-col cols="6" sm="6"></v-col>
            <v-col cols="6" sm="6" class="text-left">
              <v-btn class="primary-btn" text @click="closeconfirmDialog">{{
                $t("confirm-btn")
              }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import AUTH from "../../auth";
export default {
  name: "studentAppointments",
  data() {
    return {
      dialog: false,
      cancelDialog: false,
      walletDialog: false,
      confirmWalletPaymentDialog: false,
      page: 1,
      total: 1,
      headers: [
        {
          text: this.$i18n.t("teacher"),
          align: "center",
          sortable: false,
          value: "teacher_name",
        },
        {
          text: this.$i18n.t("sessionAppointment"),
          value: "day",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("subject"),
          value: "subject_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("specificSubject"),
          value: "notes",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("Type"),
          value: "type",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("sessionFees"),
          value: "total",
          align: "center",
          sortable: false,
        },
        { text: "", value: "actions", align: "center", sortable: false },
      ],
      sessions: [],
      counters: [],
      currentTab: "pending",
      cancellation_fees_applies: false,
      available_balance: "",
      teacher_name: "",
      amount: "",
      website_fees: "",
      totalFees: "",
      tax_percentage: "",
      tax_amount: "",
      remaining: 0,
      sessionId: "",
      successTitle: "",
      successMessage: "",
      items: [
        { text: this.$i18n.t("pendingTeacherConfirm"), value: "pending" },
        { text: this.$i18n.t("pendingPayment"), value: "confirmed" },
        { text: this.$i18n.t("upcoming"), value: "upcoming" },
        { text: this.$i18n.t("past"), value: "previous" },
        { text: this.$i18n.t("cancelled"), value: "cancelled" },
      ],
      selectedStatus: "pending",
    };
  },
  watch: {
    page: {
      handler() {
        this.getSessions();
      },
    },
  },
  methods: {
    goToPaymentPage(id, sessionType) {
      this.sessionId = id;
      this.$http
        .get(this.getApiUrl + "/payment/checkwallet/" + id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            if (response.data.data.canPayWithWallet == false) {
              if (sessionType == "multiple") {
                this.$router.push({ path: "/student/groupPayments/" + id });
              } else {
                this.$router.push({ path: "/student/payment/" + id });
              }
            } else {
              if (sessionType == "multiple") {
                this.$router.push({ path: "/student/groupPayments/" + id });
              } else {
                this.available_balance =
                  response.data.data.data.available_balance;
                this.teacher_name = response.data.data.data.teacher_name;
                this.amount = response.data.data.data.amount;
                this.website_fees = response.data.data.data.website_fees;
                this.totalFees = response.data.data.data.total;
                this.tax_percentage = response.data.data.data.tax_percentage;
                this.tax_amount = response.data.data.data.tax_amount;
                this.walletDialog = true;
              }
            }
          }
        });
    },
    closeconfirmDialog() {
      this.confirmWalletPaymentDialog = false;
    },
    payWithWallet() {
      this.$http
        .get(this.getApiUrl + "/payment/paywithwallet/" + this.sessionId, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            if (response.data.data.paid) {
              if (parseInt(response.data.data.remaining) > 0) {
                this.remaining = parseInt(response.data.data.remaining);
                this.successTitle = this.$i18n.t("paymentDone");
                this.successMessage =
                  this.$i18n.t("paymentDoneWithRemainingMessage") +
                  " " +
                  this.remaining +
                  " " +
                  this.$i18n.t("currency");
              } else {
                this.successTitle = this.$i18n.t("paymentDone");
                this.successMessage = this.$i18n.t("paymentDoneMessage");
              }
              this.walletDialog = false;
              this.confirmWalletPaymentDialog = true;
            }
          }
        });
    },
    changeStatus(status) {
      this.currentTab = status;
      if (this.currentTab == "cancelled" && this.headers.length < 8) {
        this.headers.push({
          text: "",
          value: "cancelled_by",
          align: "center",
          sortable: false,
        });
      } else {
        if (this.headers.length == 8) {
          this.headers.splice(this.headers.length - 1, 1);
        }
      }
      this.page = 1;
      this.getSessions();
    },
    getSessions() {
      this.$http
        .get(
          this.getApiUrl +
            "/student/sessions?status=" +
            this.currentTab +
            "&page=" +
            this.page,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            this.sessions = response.data.data.sessions.data;
            this.counters = response.data.data.counters;
            // this.page = response.data.data.current_page;
            this.total = response.data.data.sessions.last_page;
          }
        });
    },
    // openRatingDialog() {
    //   this.dialog = true;
    // }

    cancel(appointmentId) {
      this.cancellation_fees_applies = false;
      this.selectId = appointmentId;
      this.$http
        .get(
          this.getApiUrl +
            "/student/sessions/cancellation/check/" +
            this.selectId,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          }
        )
        .then((response) => {
          this.cancellation_fees_applies =
            response.data.data.cancellation_fees_applies;
          this.cancelDialog = true;
        });
    },

    cancelSession() {
      this.$http
        .get(this.getApiUrl + "/student/sessions/cancel/" + this.selectId, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          console.log(response.data.status.error);
          if (response.data.status.error == false) {
            this.cancelDialog = false;
            this.$refs.snack.sendSuccessAlert(response.data.status.message);
            this.getSessions();
          }
        });
    },
    closeCancelDialog() {
      this.cancelDialog = false;
    },
    closeWalletDialog() {
      this.walletDialog = false;
    },
  },
  mounted() {
    this.getSessions();
    if (window.location.protocol == "https:") {
      this.$socket
        .channel("SessionCancelled")
        .listen("SessionCancelled", (e) => {
          if (parseInt(e.student_user_id) == parseInt(AUTH.getID())) {
            this.getSessions();
          }
        });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/vuetifyCustomstyle.css";

.schedule-table {
  .student-name {
    font-size: 0.7rem !important;
    color: $main-color;
  }
  .student-img {
    margin: 0 auto;
    display: block;
    border-radius: 50%;
  }
  .date {
    color: $second-color;
  }
}

.pagination {
  margin-top: $margin-top;
}
.list-inline {
  li {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 2px;
    margin: 0 5px;
    position: relative;
    border-radius: 12px;
    .notic {
      position: absolute;
      top: -9px;
      left: 0;
      background-color: #fda5a5;
      font-size: 0.8rem;
      border-radius: 50%;
      width: 15px;
      height: 15px;
      padding-bottom: 0px;
      z-index: 2;
    }
  }
  .active {
    background-color: $main-color;
    color: #ffffff;
  }
}

ul {
  li {
    cursor: pointer;
  }
}

@media (max-width: 600px) {
  .teacher-img {
    display: none;
  }
  .v-btn {
    display: block;
    margin-bottom: 0.25rem !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .date {
    margin-bottom: 0 !important;
  }
}

.confirm-btn {
  background-color: $dialog-color;
  color: #ffffff;
}

.cancel-btn {
  color: $dialog-color;
  border: 1px solid $dialog-color;
}

.headline {
  color: $dialog-color;
}

.action-div {
  margin-bottom: 1rem !important;
}

.error-btn {
  height: 30px !important;
  min-width: 50px !important;
  padding: 0 0px !important;
}
</style>
